module.exports = __webpack_public_path__ + "img/character-2.47fefdae.webp";